
import { Component, Vue, Prop } from "vue-property-decorator";
import ProfilePictureWidget from "@/components/widgets/ProfilePictureWidget.vue";
import HiboButton from "@/components/ui/HiboButton.vue";
import HiboLoader from "@/components/ui/HiboLoader.vue";
import { IMortgageData, IMortgageComment } from "@/models/Mortgages";
import { AVALON_PROPERTIES_ID } from "@/constants";

@Component({ components: { ProfilePictureWidget, HiboButton, HiboLoader } })
export default class MortgagesComments extends Vue {
  @Prop({ type: Object, required: true })
  protected mortgage!: IMortgageData;

  protected newComment = "";
  protected loading = false;

  protected async addMortgageComment() {
    if (this.isSubmitEnabled) {
      this.loading = true;
      await this.$store.dispatch("mortgages/addMortgageComment", {
        currentMortgageId: this.mortgage.id,
        comment: this.newComment,
      });
      this.newComment = "";
      this.loading = false;
      this.$emit("mortgageUpdated", this.mortgage.id);
    }
  }

  protected get isSubmitEnabled() {
    return this.newComment.trim() !== "";
  }

  protected getDisplayName(mortgageComment: IMortgageComment): string {
    return (
      mortgageComment.housfyAccountHiboAgencyName ||
      mortgageComment.adminUserName
    );
  }

  protected get user(): any {
    return this.$store.state.auth.user;
  }

  protected get isAvalonProperties(): boolean {
    const targetId = AVALON_PROPERTIES_ID;
    return this.user?.agentId === targetId || this.user?.parentId === targetId;
  }
}
